
import { ProductCollectionModel } from '@/libs/Api';
import { CrudAction } from '@/libs/core/+state/models/crud-action';
import { CrudDataStats } from '@/libs/core/+state/models/crud-data-stats';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import { CrudQueryPredicate } from '@/libs/core/+state/models/crud-query-predicate';
import { productCollectionsStore } from '@/libs/products/+state/store';
import Page from '@/Page.vue';
import { Component, Prop, Watch, Ref } from 'vue-property-decorator';
import ProductCollectionDialog from '../components/ProductCollectionDialog.vue';
import { Guid } from '@/libs/common/functions/guid';

@Component({
    components: {
        ProductCollectionDialog,
    },
})
export default class ProductCollections extends Page {
    get headers() {
        return [
            { text: this.$i18n.t('productCollections.name'), value: 'name', align: 'left', sortable: false },
            { text: this.$i18n.t('productCollections.scrapCosts'), value: 'scrapCosts', align: 'left', sortable: false },
            { text: '', value: 'id', align: 'left', sortable: false },
        ];
    }
    itemsPerPage = 10;

    @Prop() tenantId!: string;
    @Ref() dialog!: ProductCollectionDialog;

    @Watch('itemsPerPage')
    itemsPerPageChanged(v: number) {
        window.localStorage.amsItemsPerPage = v.toString();
    }

    get loading(): boolean {
        return productCollectionsStore.useGetter(CrudGetter.Pending);
    }

    get items(): ProductCollectionModel[] {
        return [...productCollectionsStore.useGetter(CrudGetter.Data)];
    }

    get totalRows(): number {
        return ({ ...productCollectionsStore.useGetter(CrudGetter.DataStats) } as CrudDataStats)?.rowCount;
    }

    mounted() {
        this.itemsPerPage = window.localStorage.amsItemsPerPage ? Number(window.localStorage.amsItemsPerPage) : 10;
        this.load();
    }

    load() {
        productCollectionsStore.dispatch(CrudAction.GetAll, this.getPayload());
    }

    getFilters(): CrudQueryPredicate[] {
        let filters: CrudQueryPredicate[] = [];
        return filters;
    }

    getPayload() {
        return createCrudQueryPayload<ProductCollectionModel>({ field: 'name', index: 1, order: 'asc' }, this.getFilters());
    }

    open(item: ProductCollectionModel) {
        this.dialog.open(item.id!);
    }

    createItemClick() {
        this.dialog.open(Guid.EmptyGuid());
    }
}
